import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';

export const StyledCard = styled(Paper)(({ theme }) => ({
  borderRadius: 24,
  padding: theme.spacing(4),
  boxShadow: `0 18px 48px ${alpha(theme.palette.text.primary, 0.12)}`,
  border: `1px solid ${theme.palette.divider}`,
}));
